export default "__VITE_ASSET__c6c9e97d__"